import { Skeleton } from "@/components";

function MemberDetailSkeleton() {
	return (
		<div className="relative h-full bg-white flex flex-col">
			<div className="bg-gradient-member h-[24.375rem]">
				<div className="container flex flex-row justify-between items-center">
					<Skeleton className="w-10 h-10 rounded-full" />
					<Skeleton className="w-10 h-10 rounded-full" />
				</div>
			</div>
			<div className="container flex flex-col gap-2 justify-center items-center -translate-y-24">
				<Skeleton className="w-48 h-48 rounded-full" />
				<Skeleton className="w-48 h-8" />
				<div className="rounded-full p-2 flex gap-2 justify-center items-center">
					<Skeleton className="w-24 h-9 rounded-full" />
				</div>
			</div>
		</div>
	);
}

export default MemberDetailSkeleton;
